import React from 'react';

import UserSettingsForm
  from 'components/dashboard/settings-content/UserSettingsForm';

import './SettingsPageContent.css';

const SettingsPageContent = () => <UserSettingsForm />;

export default SettingsPageContent;
